<template>
  <div id="app">
    <!-- 缓存组件跳转的页面 -->
    <keep-alive>
      <router-view
        v-if="$route.meta.keepAlive"
        transition-mode="out-in"
      ></router-view>
    </keep-alive>
    <!-- 非缓存组件跳转页面 -->
    <router-view
      v-if="!$route.meta.keepAlive"
      transition-mode="out-in"
    ></router-view>
  </div>
</template>

<script>
export default {
  mounted() {},
  methods: {}
};
</script>

<style>
body {
  font-size: 16px;
  -webkit-font-smoothing: antialiased;
}
#app {
  margin: 0 auto;
  overflow-x: hidden;
  max-width: 800px;
}
</style>
